import React from 'react'
import css from './styles/messages-in-transit.css'

export default () => (
  <div className={css.wrapper}>
    <div className={css.items}>
      <span>.</span>
      <span>.</span>
      <span>.</span>
    </div>
  </div>
)



// WEBPACK FOOTER //
// ./src/components/Messages/MessagesInTransit.js